<template>
  <div class="container page" style="background-color: #1f1c1f">
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px"
        />
      </template>
      <!-- <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{$t("withdraw.with_record")}}</span>
      </template> -->
    </van-nav-bar>
    <van-cell-group>
      <van-field v-model="withdraw_money" :placeholder="$t('tqje')" />
      <van-field v-model="paypassword" :placeholder="$t('q15')" />
      <van-field v-model="payAddress" :placeholder="$t('jmhbdz')" />
    </van-cell-group>
    <div class="p_c">
      <span>{{ $t("my.balance") }}：</span>
      <span class="number"
        >{{ this.userInfo.money }}{{ $t("reservation.ge") }}</span
      >
    </div>
    <!-- <div class="p_c">{{$t('q16')}}：{{ this.userInfo.name }}</div>
    <div class="hang_p_c">
      <input type="radio" checked>
      {{$t('q17')}} ：{{bankInfo.bankinfo}} {{bankInfo.fhnumber}}
    </div> -->

    <div class="sub-btn" @click="doWithdraw()">
      {{ $t("q18") }}
    </div>
    <div class="shuoming">
      <div class="l_p q1">{{ $t("q19") }}：</div>
      <div class="l_p">1、{{ $t("q20") }}{{ withdrawRole.max }}</div>
      <div class="l_p">2、{{ $t("q21") }}{{ withdrawRole.min }}</div>
      <div class="l_p">3、{{ $t("q22") }}</div>
      <div class="l_p">4、{{ $t("q23") }}</div>
    </div>
    <!-- <div class="main">
      <div class="withdrawMoney">
        <span>{{$t("withdraw.with_money")}} ({{$t("reservation.unit")}})</span>
        <div class="money">
          <div class="moneyNumber">
           
            <van-field v-model="withdraw_money" type="number" />
          </div>
          <span class="all" @click="allMoeny()">{{$t("index.all")}}</span>
        </div>
        <div class="information">
          <div class="description">
            <van-popover v-model="showPopover" trigger="click">
              <div class="popover-body" style="padding: 10px;">
                <p>1.{{$t("withdraw.single_limit")}}{{$t("withdraw.low")}}{{this.withdrawRole.min}}{{$t("withdraw.heigh")}}{{this.withdrawRole.max}}{{$t("reservation.unit")}}</p>
                <p>2.{{$t("withdraw.with_num")}}{{this.withdrawRole.num}}{{$t("withdraw.number")}}</p>
                <p>3.{{$t("withdraw.with_tip")}}</p></div>
              <template #reference @click="withdrawInfo()">
                <van-icon name="info-o" />
                {{$t("withdraw.limit_desc")}}
              </template>
            </van-popover>
          </div>

          <div class="balance">
            <span>{{$t("my.balance")}}：</span>
            <span class="number">{{ this.userInfo.money }}{{$t("reservation.ge")}}</span>
          </div>
        </div>
      </div>
      <van-button class="withdraw_btn" type="default" @click="doWithdraw()"> {{$t("withdraw.immediately_withdraw")}}</van-button>

    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      money: "",
      paypassword: "",
      payAddress: "",
      showPopover: false,
      withdraw_money: "",
      userInfo: {},
      withdrawRole: {},
      bankInfo: {},
    };
  },
  methods: {
    getUserBankInfo() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        console.log(res, "res--87");

        if (res.code === 200) {
          this.bankInfo = res.data.info || {};
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    back() {
      return window.history.back();
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserWithdrawRole() {
      this.$http({
        method: "get",
        url: "user_get_withdraw_role",
      }).then((res) => {
        if (res.code === 200) {
          console.log(res.data, "res.data---119");
          this.withdrawRole = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    allMoeny() {
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw() {
      if (this.userInfo.is_freeze === 1) {
        this.$toast(this.$t("您资金已冻结"));
        return;
      }
      if (this.paypassword <= 0) {
        this.$toast(this.$t("q24"));
        return false;
      } else if (this.withdraw_money <= 0) {
        this.$toast(this.$t("setting.correct_money"));
        return false;
      } else if (!this.payAddress) {
        this.$toast(this.$t("qsrjmhbdz"));
        return false;
      } else {
        this.$http({
          method: "post",
          data: {
            money: this.withdraw_money,
            paypassword: this.paypassword,
            addr: this.payAddress,
          },
          url: "user_set_withdraw",
        }).then((res) => {
          if (res.code === 200) {
            location.reload();
            this.$toast(res.msg);
            this.getUserInfo();
            this.getUserWithdrawRole();
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        });
      }
    },
    withdrawInfo() {
      this.showPopover = true;
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  },
  mounted() {
    this.getUserBankInfo();
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.p_c {
  color: #fff;
  padding: 0 30px 20px;
  font-size: 28px;
}
.hang_p_c {
  padding: 0 0px 20px;
  border-bottom: 1px solid #c5a081;
  margin: 0 20px;
  color: #c5a081;
  font-size: 28px;
}
.sub-btn {
  background: linear-gradient(#fde3ca, #e7b486);

  display: inline-block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 2rem;
  margin: 40px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}
.shuoming {
  background: #2e2e2e;
  color: #c1c1c1;
  padding: 40px 36px;
  .l_p {
    font-size: 26px;
    margin-top: 16px;
    &.q1 {
      font-size: 30px;
    }
  }
}
/deep/ .van-field__label {
  color: #ccc;
}
.van-cell-group {
  background-color: transparent;
  padding: 30px 0;
  &:after {
    display: none;
  }
}
.van-cell {
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  & + .van-cell {
    margin-top: 30px;
  }

  /deep/ .van-field__control {
    color: #f3c7a2;
  }
  &:after {
    display: none;
  }
}

.container p {
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.container .main {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}
.container .main .withdrawMoney {
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .money .moneyNumber {
  font-size: 50px;
  display: flex;
  flex-direction: row;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money .all {
  color: #d10404;
}
.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0 !important;
}
.container .main .withdrawMoney .information {
  padding-bottom: 30px;
}
.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .information .balance .number {
  color: #d10404;
}
.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #e6c3a1, #7e5678);
}

@media screen and (min-width: 1024px) {
  .container {
    width: 430px;
    margin: 0 auto;
    height: 100vh;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8),
      0 0 0 1px rgba(255, 255, 255, 0.05);
  }
  .nav-bar {
    height: 50px;
  }

  /* 输入区域整体间距 */
  .van-cell-group {
    padding: 20px 0;
  }

  /* 输入框（重点） */
  .van-cell {
    margin: 0 30px 18px !important;
    padding: 0px 16px;
    font-size: 14px;
    border-radius: 10px;
    transition: all 0.2s;
  }

  .van-cell:hover {
    border-color: #e7b486;
    box-shadow: 0 0 10px rgba(231, 180, 134, 0.2);
  }

  ::v-deep .van-field__control {
    font-size: 14px;
  }

  /* 余额显示 */
  .p_c {
    font-size: 14px;
    padding: 10px 30px 20px;
    color: #aaa;
  }

  .p_c .number {
    color: #e7b486;
    font-weight: bold;
    margin-left: 5px;
  }

  /* 提现按钮 */
  .sub-btn {
    margin: 30px 30px;
    padding: 14px 0;
    font-size: 16px;
    border-radius: 30px;
    transition: all 0.2s;
  }

  .sub-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(231, 180, 134, 0.4);
  }

  /* 说明模块（重点优化） */
  .shuoming {
    margin: 20px 30px 30px;
    padding: 20px 20px;
    border-radius: 12px;
    font-size: 13px;
    line-height: 1.6;
  }

  .shuoming .l_p {
    font-size: 13px;
    margin-top: 10px;
  }

  .shuoming .l_p.q1 {
    font-size: 15px;
    font-weight: bold;
    color: #fff;
  }
}
</style>
